module.exports = __webpack_public_path__ + "img/Narnia.e347c025.jpg";